<div class="div_waiter_tabview">
    <div class="w-100">
      <div class="d-flex flex-column">
        <label class="wtr_venue_info_32 ellipsis">{{ venueName }}</label>
      </div>
    </div>
    <div class="wtr-container">
      <p-tabView (onChange)="getWtrByStatus($event, true)" [(activeIndex)]="activeIndex">
        <p-tabPanel>
          <ng-template pTemplate="header">
            <span class="p-tabview-title">{{'WTR.TABLES' | translate}}
            </span>
          </ng-template>
          <ng-container *ngTemplateOutlet="tables"></ng-container>
        </p-tabPanel>
        <p-tabPanel header="{{'WTR.ALL_ORDERS' | translate}}">
          <ng-container *ngTemplateOutlet="allOrders"></ng-container>
        </p-tabPanel>
        <p-tabPanel header="{{'WTR.ALL_BILLS' | translate}}">
          <ng-container *ngTemplateOutlet="allBills"></ng-container>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>

  <ng-template #tables>
    <div class="div_capacity d-flex flex-row justify-content-around my-4">
      <div class="capacity_group" *ngFor="let capacityGroup of capacity?.capacityGroups">
        <div class="capacity_group_name" [ngClass]="[(selectedCapacityGroupIndex == capacityGroup.index)? 'capacity_group_active'  : '',]" (click)="changeCapacityGroupIndex(capacityGroup)">{{capacityGroup.name}}</div>
      </div>
    </div>
    <ng-container>
      <div *ngFor="let capacityGroup of capacityGroupList">
        <div class="tables_container" *ngIf="this.selectedCapacityGroupIndex == capacityGroup.index">
          <div (click)="openWaiterTable(table)" class="div_card_table" *ngFor="let table of capacityGroup.capacityTables" [ngClass]="[(table.status == TableHasOrder)? 'capacity_table_active'  : '',]">
            <div>{{table.name}}</div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

<ng-template #allOrders>
  <ng-container *ngIf="orderBillsList && orderBillsList.length > 0">
    <div class="order_status_card">
    <div *ngFor="let orderBill of orderBillsList">
      <div *ngFor="let order of orderBill.orders">
        <div class="order_status_card_wrapper">
          <div class="order_status_card_items">
            <div class="order_status_card_order_number">{{'ORDER.ORDER_NUMBER' | translate | uppercase}}: #{{orderBill.billNumber}}</div>
            <div *ngFor="let item of order.items">
              <div class="d-flex justify-content-between"><span>{{item.venueMenuItemName}}</span><span>{{item.quantity}}</span></div>
            </div>
          </div>
          <div *ngIf="order.note && order.note!=''" class="order_status_card_notes">
            Note:
            <div>{{order.note}}</div>
          </div>
          <div class="order_status_card_total text-end">
            {{'ORDER_DETAILS.TOTAL' | translate }} {{order.price | customCurrencyPipe: orderBill.currencyShortName :'1.0-2'}}
          </div>
        </div>
      </div>
    </div>
    </div>
  </ng-container>
</ng-template>


  <ng-template #allBills>
    <div *ngIf="orderBillsList && orderBillsList.length > 0" class="table-bill">
    <table class="table table-borderless bill_status_card">
      <thead class="sticky-top sticky_top_bcg">
      <tr>
        <th scope="col">{{'ORDER.ORDER_NUMBER_SHORT' | translate | uppercase}}</th>
        <th scope="col">{{'ORDER.TOTAL' | translate | uppercase}}</th>
        <th scope="col">{{'ORDER.STATUS' | translate | uppercase}}</th>
      </tr>
      </thead>
      <tbody class="mx-2">
      <ng-container *ngFor="let orderBillsForTable of orderBills | keyvalue">
        <tr class="table_name_bill_status_row">
          <td colspan="3">{{'ORDER.TABLE' | translate | uppercase}} {{orderBillsForTable.key}}</td>
        </tr>
        <ng-container *ngFor="let orderBill of orderBillsForTable.value">
          <tr>
            <td>#{{orderBill.billNumber}}</td>
            <td>{{ displayPriceWithTaxWithCalculatedTax(orderBill)  | customCurrencyPipe: orderBill.currencyShortName :'1.0-2'}} </td>
            <td *ngIf="orderBill.status == orderStatusEnum.Paid || orderBill.status == orderStatusEnum.Closed; then paid else unpaid"></td>
          </tr>
          <ng-container *ngFor="let splitBill of orderBill.orderBills">
            <tr>
              <td>#{{splitBill.billNumber}}</td>
              <td>{{displayPriceWithTaxWithCalculatedTax(splitBill) | customCurrencyPipe: orderBill.currencyShortName :'1.0-2'}}</td>
              <td *ngIf="splitBill.status == orderStatusEnum.Paid || splitBill.status == orderStatusEnum.Closed; then paid else unpaid"></td>
            </tr>
          </ng-container>
        </ng-container>
      </ng-container>
      </tbody>
    </table>
    </div>
  </ng-template>
<ng-template #unpaid><div class="unpaid_bill_status">{{'ORDER_BILL.UNPAID' | translate | uppercase }}</div></ng-template>
<ng-template #paid><div class="paid_bill_status">{{'ORDER_BILL.PAID' | translate | uppercase}}</div></ng-template>
